import { GlDisclosureDropdown, GlDisclosureDropdownItem, GlIcon, GlLink, GlButton } from '@gitlab/ui';
import { s__ } from '~/locale';
import { helpPagePath } from '~/helpers/help_page_helper';
import { isLoggedIn } from '~/lib/utils/common_utils';
import { visitUrl } from '~/lib/utils/url_utility';
import WorkItemsNewSavedViewModal from './work_items_new_saved_view_modal.vue';
import WorkItemsExistingSavedViewsModal from './work_items_existing_saved_views_modal.vue';
export default {
    name: 'WorkItemsCreateSavedViewDropdown',
    components: {
        GlIcon,
        GlLink,
        GlDisclosureDropdown,
        GlDisclosureDropdownItem,
        WorkItemsNewSavedViewModal,
        WorkItemsExistingSavedViewsModal,
        GlButton
    },
    i18n: {
        addViewButtonText: s__('WorkItem|Add view'),
        newViewTitle: s__('WorkItem|New view'),
        existingViewDropdownTitle: s__('WorkItem|Browse views'),
        subscriptionLimitWarningMessage: s__('WorkItem|You have reached the maximum number of views in your list.'),
        learnMore: s__('WorkItem|Learn more.')
    },
    savedViewLimitsHelpPath: helpPagePath('user/work_items/saved_views.md', {
        anchor: 'saved-view-limits'
    }),
    inject: [
        'canCreateSavedView',
        'signInPath'
    ],
    props: {
        fullPath: {
            type: String,
            required: true
        },
        sortKey: {
            type: String,
            required: true
        },
        filters: {
            type: Object,
            required: false,
            default: ()=>{}
        },
        displaySettings: {
            type: Object,
            required: false,
            default: ()=>{}
        },
        showSubscriptionLimitWarning: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'subscribe-from-modal'
    ],
    data () {
        return {
            isNewViewModalVisible: false,
            isExistingViewModalVisible: false,
            isLoggedIn: isLoggedIn()
        };
    },
    methods: {
        openExistingViewModal () {
            if (this.isLoggedIn) {
                this.isExistingViewModalVisible = true;
            } else {
                visitUrl(this.signInPath);
            }
        }
    }
};
